import React from "react";
import Comments from "./Comments";
import CommentForm from "./CommentForm";
import Sidebar from "./Sidebar";
import { formatDate } from "../../utils/dateFormatter";
import { BaseURL } from "../../APIs/APIUrls";
import Faqs2 from "../otherPages/Faqs2";
import { Link } from "react-router-dom";

const getYoutubeEmbedUrl = (url) => {
  if (!url) return "";

  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.pathname.includes("/embed/")) {
      return url;
    }

    let videoId = "";

    if (parsedUrl.hostname.includes("youtu.be")) {
      videoId = parsedUrl.pathname.replace("/", "");
    } else {
      videoId = parsedUrl.searchParams.get("v") || "";
    }

    return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
  } catch (error) {
    return url;
  }
};

const normalizeText = (value) => String(value || "").trim().toLowerCase();

const findRelatedPropertyByCity = (allRows, selectedRow) => {
  if (!Array.isArray(allRows) || !selectedRow) {
    return [];
  }

  const selectedCity = normalizeText(selectedRow?.City || selectedRow?._objDetailPage?.City);
  const selectedPageUrl = normalizeText(selectedRow?.PageURL || selectedRow?.PageUrl || selectedRow?.pageURL);

  if (!selectedCity) {
    return [];
  }

  return allRows.filter((row) => {
    const rowCity = normalizeText(row?.City || row?._objDetailPage?.City);
    const rowPageUrl = normalizeText(row?.PageURL || row?.PageUrl || row?.pageURL);
    return rowCity === selectedCity && rowPageUrl !== selectedPageUrl;
  });
};

const resolveRelatedHref = (rawUrl) => {
  const cleanedUrl = String(rawUrl || "").trim();
  if (!cleanedUrl) {
    return "#";
  }

  if (/^https?:\/\//i.test(cleanedUrl) || cleanedUrl.startsWith("/")) {
    return cleanedUrl;
  }

  return `/${cleanedUrl}`;
};

const getUniqueCities = (allRows) => {
  if (!Array.isArray(allRows)) {
    return [];
  }

  const uniqueCitiesSet = new Set();
  allRows.forEach((row) => {
    const city = row?.City || row?._objDetailPage?.City;
    if (city) {
      uniqueCitiesSet.add(city);
    }
  });

  return Array.from(uniqueCitiesSet).map((city) => ({
    City: city,
  }));
};

export default function BlogDetails2({ pageUrlMasterData, filteredpageUrlMasterData }) {

  const [IsReadMore, setIsReadMore] = React.useState(false);
  const [RelatedProperty, SetRelatedProperty] = React.useState([]);
  const [PopularCities, SetPopularCities] = React.useState([]);
  

  React.useEffect(() => {
    const result = findRelatedPropertyByCity(pageUrlMasterData, filteredpageUrlMasterData);
    SetRelatedProperty(result);
  }, [pageUrlMasterData, filteredpageUrlMasterData]);

  React.useEffect(() => {
    const uniqueCities = getUniqueCities(pageUrlMasterData);
    SetPopularCities(uniqueCities);
  }, [pageUrlMasterData]);

  // console.log("BlogDetails2 filteredpageUrlMasterData: ", filteredpageUrlMasterData);

  const viewContentWriterProfilePage = (profileData) => {
    if (!profileData) return;

    localStorage.setItem("SelectedBloggerProfile", JSON.stringify(profileData));
    const profileURL = profileData?.ProfileURL || "";
    const userId = profileData?.UserId || "";
    if (profileURL && userId) {
      const authorUrl = `/author/${userId}-${profileURL}`;
      window.open(authorUrl, "_blank", "noopener,noreferrer");
    }
  };


  return (<>
    <section className="flat-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="flat-blog-detail">
              <div className="pb-30 line-b" style={{ borderTop: "1px solid #e4e4e4", paddingTop: "30px" }}>
                <p className="text-black-2 fw-6">
                  {
                    filteredpageUrlMasterData?._objDetailPage?.ShortDescription
                  }
                </p>
                <figure className="my-30  o-hidden mb-0">
                  <img
                    className="lazyload w-100"
                    alt={filteredpageUrlMasterData?._objDetailPage?.ImageAltText}
                    src={BaseURL + filteredpageUrlMasterData?._objDetailPage?.ImagePath}
                    width={840}
                    height={500}
                    title={filteredpageUrlMasterData?._objDetailPage?.ImageTitle}
                  />
                  {filteredpageUrlMasterData?._objDetailPage?.ImageCaption ? (
                    <figcaption className="text-variant-1 mt-8" style={{ marginBottom: "10px", paddingLeft: "5px" }}>
                      {filteredpageUrlMasterData?._objDetailPage?.ImageCaption}
                    </figcaption>
                  ) : null}
                </figure>
                <div className="mb-30 pb-30 line-b">
                  <h1 className="title fw-8" style={{ fontSize: "1.8rem", lineHeight: "44px",marginBottom:"8px" }}>
                    {filteredpageUrlMasterData?._objDetailPage?.Title}
                  </h1>
                  <ul className="meta-blog">
                    <li className="item">
                      <Link onClick={()=>viewContentWriterProfilePage(filteredpageUrlMasterData?._objDetailPage?._objAUserProfile)} >
                        <svg
                          className="icon"
                          width={16}
                          height={16}
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9883 12.4831C11.5225 11.8664 10.9198 11.3662 10.2278 11.022C9.53575 10.6779 8.77324 10.4991 8.00033 10.4998C7.22743 10.4991 6.46492 10.6779 5.77288 11.022C5.08084 11.3662 4.47816 11.8664 4.01233 12.4831M11.9883 12.4831C12.8973 11.6746 13.5384 10.6088 13.8278 9.4272C14.1172 8.24555 14.0405 7.00386 13.608 5.86679C13.1754 4.72972 12.4075 3.75099 11.4059 3.0604C10.4044 2.36982 9.21656 2 8 2C6.78344 2 5.59562 2.36982 4.59407 3.0604C3.59252 3.75099 2.82455 4.72972 2.39202 5.86679C1.95949 7.00386 1.88284 8.24555 2.17221 9.4272C2.46159 10.6088 3.10333 11.6746 4.01233 12.4831M11.9883 12.4831C10.891 13.4619 9.47075 14.0019 8.00033 13.9998C6.52969 14.0021 5.10983 13.4621 4.01233 12.4831M10.0003 6.4998C10.0003 7.03024 9.78962 7.53894 9.41455 7.91402C9.03948 8.28909 8.53077 8.4998 8.00033 8.4998C7.4699 8.4998 6.96119 8.28909 6.58612 7.91402C6.21105 7.53894 6.00033 7.03024 6.00033 6.4998C6.00033 5.96937 6.21105 5.46066 6.58612 5.08559C6.96119 4.71052 7.4699 4.4998 8.00033 4.4998C8.53077 4.4998 9.03948 4.71052 9.41455 5.08559C9.78962 5.46066 10.0003 5.96937 10.0003 6.4998Z"
                            stroke="#A3ABB0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg> &nbsp;
                        <span className="text-primary fw-6">{filteredpageUrlMasterData?._objDetailPage?._objAUserProfile?.Name}</span>
                      </Link>

                    </li>

                    <li className="item">
                      <svg
                        className="icon"
                        width={16}
                        height={16}
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.5 2V3.5M11.5 2V3.5M2 12.5V5C2 4.60218 2.15804 4.22064 2.43934 3.93934C2.72064 3.65804 3.10218 3.5 3.5 3.5H12.5C12.8978 3.5 13.2794 3.65804 13.5607 3.93934C13.842 4.22064 14 4.60218 14 5V12.5M2 12.5C2 12.8978 2.15804 13.2794 2.43934 13.5607C2.72064 13.842 3.10218 14 3.5 14H12.5C12.8978 14 13.2794 13.842 13.5607 13.5607C13.842 13.2794 14 12.8978 14 12.5M2 12.5V7.5C2 7.10218 2.15804 6.72064 2.43934 6.43934C2.72064 6.15804 3.10218 6 3.5 6H12.5C12.8978 6 13.2794 6.15804 13.5607 6.43934C13.842 6.72064 14 7.10218 14 7.5V12.5"
                          stroke="#A3ABB0"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="text-variant-1">{formatDate(filteredpageUrlMasterData?._objDetailPage?.CreatedOn)}</span>
                    </li>
                  </ul>

                </div>
                <h5 className="mb-16 text-black-2">
                  {filteredpageUrlMasterData?._objDetailPage?.ImageTitle}
                </h5>
                <div id="description"
                  className="blog-description-content"
                  dangerouslySetInnerHTML={{
                    __html:
                      filteredpageUrlMasterData?._objDetailPage?.Description || "",
                  }}
                />

                {
                  IsReadMore && filteredpageUrlMasterData?._lstTOC?.length > 0 && (<>
                    <h5 id="tochead" className="mb-16 text-black-2 " style={{ marginTop: "45px" }}>
                      {filteredpageUrlMasterData?._objDetailPage?.TOCHeading}
                    </h5>
                    <div className="my-20 flat-quote">
                      {
                        filteredpageUrlMasterData?._lstTOC?.map((item, index) => (
                          <blockquote className="quote text-primary mb-1">
                            <ol style={{ paddingLeft: "5px" }} >
                              <a href={`#toc_${item.TOCId}`}>
                                <li key={index}>{index + 1}. {item.Title}</li>
                              </a>
                            </ol>
                          </blockquote>
                        ))
                      }

                    </div>

                    {
                      filteredpageUrlMasterData?._lstTOC?.map((item, index) => (<>
                        <h5 className="mb-16 mt-20 text-black-2" style={{ fontSize: "17px" }} id={`toc_${item.TOCId}`}>
                          {index + 1}. {item.Title}
                        </h5>
                        <div className="box-image grid-2 gap-10 mb-30">
                          {
                            item.ImagePath && (

                              <figure className="overflow-hidden round-30 mb-0">
                                <img
                                  className="w-100"
                                  alt={item.ImageAltText}
                                  src={BaseURL + item.ImagePath}
                                  width={400}
                                  height={253}
                                  title={item.ImageTitle}
                                  style={{
                                    borderRadius: "inherit"
                                  }}
                                  loading="lazy"
                                />
                                {item.ImageCaption ? (
                                  <figcaption className="text-variant-1 mt-8">{item.ImageCaption}</figcaption>
                                ) : null}
                              </figure>

                            )
                          }
                          {
                            item.YoutubeVideoURL && (
                              <div className="overflow-hidden round-30 mb-0" style={{ aspectRatio: "16 / 10" }}>
                                <iframe
                                  className="w-100 h-100"
                                  src={getYoutubeEmbedUrl(item.YoutubeVideoURL)}
                                  title={item.ImageTitle || "YouTube video player"}
                                  loading="lazy"
                                  frameBorder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                  allowFullScreen
                                  referrerPolicy="strict-origin-when-cross-origin"
                                />
                              </div>

                            )
                          }
                        </div>
                        <div
                          className="blog-description-content"
                          dangerouslySetInnerHTML={{
                            __html:
                              item.Description || "",
                          }} />
                      </>
                      ))
                    }
                  </>)
                }
                {
                  filteredpageUrlMasterData?._lstTOC?.length > 0 && (
                    <button className="mt-20 mb-30 btn btn-primary"
                      onClick={() => {
                        setIsReadMore(!IsReadMore);
                        if (!IsReadMore) {
                          document.getElementById("description")?.scrollIntoView({ behavior: "smooth" });
                        }
                        else {
                          document.getElementById("tochead")?.scrollIntoView({ behavior: "smooth" });
                        }
                      }}

                    >
                      {IsReadMore ? "Read Less" : "Read More"}
                    </button>
                  )
                }

              </div>
              {
                filteredpageUrlMasterData?._lstFAQ?.length > 0 && (
                  <>
                    <Faqs2 faqTitle={filteredpageUrlMasterData?._objDetailPage?.FAQHeading || "Frequently Asked Questions"} allFaqs={filteredpageUrlMasterData?._lstFAQ} />
                  </>
                )
              }
              {
                RelatedProperty?.length > 0 && (
                  <div className="related-properties pb-30 line-b mt-10">
                    <h5 className="related-properties-heading  text-black-2 " style={{ marginBottom: "2px" }}>{`Related Properties`.toUpperCase()}</h5>
                    <ul className="related-properties-list">
                      {RelatedProperty?.length > 0 ? (
                        RelatedProperty.map((item, index) => (
                          <li
                            className="related-properties-item"
                            key={item?.PageURL || item?.PageUrl || item?.pageURL || item?.Id || index}
                          >
                            <a
                              href={resolveRelatedHref(item?.PageURL || item?.PageUrl || item?.pageURL)}
                              title={item?.PageTitle || item?._objDetailPage?.Title || item?.Title || "Related Property"}
                            >
                              <p>{item?.PageTitle || item?._objDetailPage?.Title || item?.Title || "Related Property"}</p>
                            </a>
                          </li>
                        ))
                      ) : null}
                    </ul>
                  </div>
                )
              }
              {
                PopularCities?.length > 0 && (
                  <div className="related-properties pb-30 line-b mt-10">
                    <h5 className="related-properties-heading  text-black-2 " style={{ marginBottom: "2px" }}>{`Popular Cities`.toUpperCase()}</h5>
                    <ul className="related-properties-list">
                      {PopularCities?.length > 0 ? (
                        PopularCities.map((item, index) => (
                          <li
                            className="related-properties-item"
                            key={item?.City || index}
                          >
                            <a
                              href="#"
                              title={item?.City || "Popular City"}
                            >
                              <p>{item?.City || "Popular City"}</p>
                            </a>
                          </li>
                        ))
                      ) : null}
                    </ul>
                  </div>
                )
              }

              {/* <div className="pb-30" style={{ paddingTop: "30px" }}>
                <h5 className="related-properties-heading  text-black-2 " style={{ marginBottom: "15px", fontSize: "17px" }}>{`Content by`.toUpperCase()}</h5>
                <ul className="meta-blog">
                  <li className="item">
                    <svg
                      className="icon"
                      width={16}
                      height={16}
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.9883 12.4831C11.5225 11.8664 10.9198 11.3662 10.2278 11.022C9.53575 10.6779 8.77324 10.4991 8.00033 10.4998C7.22743 10.4991 6.46492 10.6779 5.77288 11.022C5.08084 11.3662 4.47816 11.8664 4.01233 12.4831M11.9883 12.4831C12.8973 11.6746 13.5384 10.6088 13.8278 9.4272C14.1172 8.24555 14.0405 7.00386 13.608 5.86679C13.1754 4.72972 12.4075 3.75099 11.4059 3.0604C10.4044 2.36982 9.21656 2 8 2C6.78344 2 5.59562 2.36982 4.59407 3.0604C3.59252 3.75099 2.82455 4.72972 2.39202 5.86679C1.95949 7.00386 1.88284 8.24555 2.17221 9.4272C2.46159 10.6088 3.10333 11.6746 4.01233 12.4831M11.9883 12.4831C10.891 13.4619 9.47075 14.0019 8.00033 13.9998C6.52969 14.0021 5.10983 13.4621 4.01233 12.4831M10.0003 6.4998C10.0003 7.03024 9.78962 7.53894 9.41455 7.91402C9.03948 8.28909 8.53077 8.4998 8.00033 8.4998C7.4699 8.4998 6.96119 8.28909 6.58612 7.91402C6.21105 7.53894 6.00033 7.03024 6.00033 6.4998C6.00033 5.96937 6.21105 5.46066 6.58612 5.08559C6.96119 4.71052 7.4699 4.4998 8.00033 4.4998C8.53077 4.4998 9.03948 4.71052 9.41455 5.08559C9.78962 5.46066 10.0003 5.96937 10.0003 6.4998Z"
                        stroke="#A3ABB0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="text-primary fw-6">{filteredpageUrlMasterData?._objDetailPage?._objAUserProfile?.Name}</span>
                  </li>

                  <li className="item">
                    <svg
                      className="icon"
                      width={16}
                      height={16}
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.5 2V3.5M11.5 2V3.5M2 12.5V5C2 4.60218 2.15804 4.22064 2.43934 3.93934C2.72064 3.65804 3.10218 3.5 3.5 3.5H12.5C12.8978 3.5 13.2794 3.65804 13.5607 3.93934C13.842 4.22064 14 4.60218 14 5V12.5M2 12.5C2 12.8978 2.15804 13.2794 2.43934 13.5607C2.72064 13.842 3.10218 14 3.5 14H12.5C12.8978 14 13.2794 13.842 13.5607 13.5607C13.842 13.2794 14 12.8978 14 12.5M2 12.5V7.5C2 7.10218 2.15804 6.72064 2.43934 6.43934C2.72064 6.15804 3.10218 6 3.5 6H12.5C12.8978 6 13.2794 6.15804 13.5607 6.43934C13.842 6.72064 14 7.10218 14 7.5V12.5"
                        stroke="#A3ABB0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="text-variant-1">{formatDate(filteredpageUrlMasterData?._objDetailPage?.CreatedOn)}</span>
                  </li>
                </ul>
              </div>

              <div className="wd-social blog-details-social">
                <ul className="list-social d-flex align-items-center">
                  {filteredpageUrlMasterData?._objDetailPage?._objAUserProfile?.Facebook && (
                    <li>
                      <a href={filteredpageUrlMasterData?._objDetailPage?._objAUserProfile?.Facebook} target="_blank" className="box-icon w-40 social">
                        <svg
                          className="icon"
                          width={9}
                          height={16}
                          viewBox="0 0 9 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.60547 9L8.00541 6.10437H5.50481V4.22531C5.50481 3.43313 5.85413 2.66094 6.97406 2.66094H8.11087V0.195625C8.11087 0.195625 7.07925 0 6.09291 0C4.03359 0 2.68753 1.38688 2.68753 3.8975V6.10437H0.398438V9H2.68753V16H5.50481V9H7.60547Z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>
                    </li>
                  )

                  }
                  {filteredpageUrlMasterData?._objDetailPage?._objAUserProfile?.Twitter && (
                    <li>
                      <a href={filteredpageUrlMasterData?._objDetailPage?._objAUserProfile?.Twitter} target="_blank" className="box-icon w-40 social">
                        <svg
                          className="icon"
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.30314 5.92804L13.4029 0H12.1944L7.7663 5.14724L4.22958 0H0.150391L5.4986 7.78354L0.150391 14H1.35894L6.03514 8.56434L9.77017 14H13.8494L8.30284 5.92804H8.30314ZM6.64787 7.85211L6.10598 7.07705L1.79439 0.909771H3.65065L7.13015 5.88696L7.67204 6.66202L12.195 13.1316H10.3387L6.64787 7.85241V7.85211Z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>
                    </li>
                  )}

                  {filteredpageUrlMasterData?._objDetailPage?._objAUserProfile?.Instagram && (
                    <li>
                      <a href={filteredpageUrlMasterData?._objDetailPage?._objAUserProfile?.Instagram} target="_blank" className="box-icon w-40 social">
                        <svg
                          className="icon"
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.99812 4.66567C5.71277 4.66567 4.66383 5.71463 4.66383 7C4.66383 8.28537 5.71277 9.33433 6.99812 9.33433C8.28346 9.33433 9.3324 8.28537 9.3324 7C9.3324 5.71463 8.28346 4.66567 6.99812 4.66567ZM13.9992 7C13.9992 6.03335 14.008 5.07545 13.9537 4.11055C13.8994 2.98979 13.6437 1.99512 12.8242 1.17556C12.0029 0.35426 11.01 0.100338 9.88927 0.0460516C8.92263 -0.00823506 7.96475 0.000520879 6.99987 0.000520879C6.03323 0.000520879 5.07536 -0.00823506 4.11047 0.0460516C2.98973 0.100338 1.99508 0.356011 1.17554 1.17556C0.354253 1.99687 0.100336 2.98979 0.0460508 4.11055C-0.00823491 5.0772 0.00052087 6.0351 0.00052087 7C0.00052087 7.9649 -0.00823491 8.92455 0.0460508 9.88945C0.100336 11.0102 0.356004 12.0049 1.17554 12.8244C1.99683 13.6457 2.98973 13.8997 4.11047 13.9539C5.07711 14.0082 6.03499 13.9995 6.99987 13.9995C7.9665 13.9995 8.92438 14.0082 9.88927 13.9539C11.01 13.8997 12.0047 13.644 12.8242 12.8244C13.6455 12.0031 13.8994 11.0102 13.9537 9.88945C14.0097 8.92455 13.9992 7.96665 13.9992 7ZM6.99812 10.5917C5.01056 10.5917 3.40651 8.98759 3.40651 7C3.40651 5.01241 5.01056 3.40832 6.99812 3.40832C8.98567 3.40832 10.5897 5.01241 10.5897 7C10.5897 8.98759 8.98567 10.5917 6.99812 10.5917ZM10.7368 4.10004C10.2728 4.10004 9.89802 3.72529 9.89802 3.26122C9.89802 2.79716 10.2728 2.42241 10.7368 2.42241C11.2009 2.42241 11.5756 2.79716 11.5756 3.26122C11.5758 3.37142 11.5542 3.48056 11.5121 3.58239C11.47 3.68422 11.4082 3.77675 11.3303 3.85467C11.2523 3.93258 11.1598 3.99437 11.058 4.03647C10.9562 4.07858 10.847 4.10018 10.7368 4.10004Z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>
                    </li>
                  )}

                  {filteredpageUrlMasterData?._objDetailPage?._objAUserProfile?.Youtube && (
                    <li>
                      <a href={filteredpageUrlMasterData?._objDetailPage?._objAUserProfile?.Youtube} target="_blank" className="box-icon w-40 social">
                        <svg
                          className="icon"
                          width={16}
                          height={12}
                          viewBox="0 0 16 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.6657 1.76024C15.4817 1.06737 14.9395 0.521689 14.2511 0.336504C13.0033 0 8 0 8 0C8 0 2.99669 0 1.7489 0.336504C1.06052 0.521718 0.518349 1.06737 0.334336 1.76024C0 3.01611 0 5.63636 0 5.63636C0 5.63636 0 8.25661 0.334336 9.51248C0.518349 10.2053 1.06052 10.7283 1.7489 10.9135C2.99669 11.25 8 11.25 8 11.25C8 11.25 13.0033 11.25 14.2511 10.9135C14.9395 10.7283 15.4817 10.2053 15.6657 9.51248C16 8.25661 16 5.63636 16 5.63636C16 5.63636 16 3.01611 15.6657 1.76024ZM6.36363 8.01535V3.25737L10.5454 5.63642L6.36363 8.01535Z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>
                    </li>
                  )}

                   <li>
                    <a href="#" className="box-icon w-40 social">
                      <svg
                        className="icon"
                        width={13}
                        height={16}
                        viewBox="0 0 13 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.53967 0C3.2506 0 0 2.19271 0 5.74145C0 7.99827 1.26947 9.28056 2.03884 9.28056C2.3562 9.28056 2.53893 8.39578 2.53893 8.14574C2.53893 7.8476 1.77918 7.21287 1.77918 5.97226C1.77918 3.39486 3.74108 1.5676 6.28001 1.5676C8.4631 1.5676 10.0788 2.80821 10.0788 5.08748C10.0788 6.78972 9.39597 9.98261 7.18402 9.98261C6.3858 9.98261 5.70298 9.40558 5.70298 8.57851C5.70298 7.36675 6.54929 6.19345 6.54929 4.94322C6.54929 2.82103 3.53912 3.20572 3.53912 5.7703C3.53912 6.30886 3.60644 6.90512 3.84686 7.3956C3.40448 9.2998 2.50046 12.1369 2.50046 14.0988C2.50046 14.7046 2.58702 15.3009 2.64472 15.9068C2.75371 16.0286 2.69922 16.0158 2.86591 15.9549C4.4816 13.7429 4.42389 13.3102 5.1548 10.4154C5.5491 11.1655 6.56852 11.5694 7.37636 11.5694C10.7808 11.5694 12.31 8.25152 12.31 5.26059C12.31 2.07731 9.55946 0 6.53967 0Z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                  </li>  <li>
                      <a href="#" className="box-icon w-40 social">
                        <svg
                          className="icon"
                          width={16}
                          height={16}
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.58151 16H0.264292V5.31762H3.58151V16ZM1.92111 3.86044C0.860376 3.86044 0 2.98185 0 1.92111C7.59231e-09 1.4116 0.202403 0.92296 0.562681 0.562681C0.92296 0.202403 1.4116 0 1.92111 0C2.43063 0 2.91927 0.202403 3.27955 0.562681C3.63983 0.92296 3.84223 1.4116 3.84223 1.92111C3.84223 2.98185 2.98149 3.86044 1.92111 3.86044ZM15.9968 16H12.6867V10.7999C12.6867 9.56057 12.6617 7.97125 10.962 7.97125C9.23735 7.97125 8.97306 9.31771 8.97306 10.7106V16H5.65941V5.31762H8.84091V6.77479H8.88734C9.33021 5.93549 10.412 5.04976 12.026 5.04976C15.3832 5.04976 16.0004 7.26052 16.0004 10.132V16H15.9968Z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>
                    </li> 

                </ul>
              </div> */}

              {/* <div className="mt-16 d-flex justify-content-between flex-wrap gap-16">
                <div className="d-flex flex-wrap align-items-center gap-12">
                  <span className="text-black fw-6">Tag:</span>
                  <ul className="d-flex flex-wrap gap-9">
                    <li>
                      <a href="#" className="blog-tag">
                        Furniture
                      </a>
                    </li>
                    <li>
                      <a href="#" className="blog-tag">
                        Interior
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="d-flex flex-wrap align-items-center gap-16">
                  <span className="font-rubik text-variant-1">
                    Share this post:
                  </span>
                  <ul className="d-flex flex-wrap gap-12">
                    <li>
                      <a href="#" className="box-icon line w-44 round">
                        <i className="icon icon-fb" />
                      </a>
                    </li>
                    <li>
                      <a href="#" className="box-icon line w-44 round">
                        <i className="icon icon-x" />
                      </a>
                    </li>
                    <li>
                      <a href="#" className="box-icon line w-44 round">
                        <i className="icon icon-in" />
                      </a>
                    </li>
                    <li>
                      <a href="#" className="box-icon line w-44 round">
                        <i className="icon icon-instargram" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div> */}
              {/* <div className="wrap-review">
                <div className="pb-12 line-b mb-0">
                  <h5 className="text-black-2">Comment (4)</h5>
                </div>
                <ul className="box-review">
                  <Comments />
                </ul>
              </div>
              <div className="wrap-form-comment">
                <h5 className="text-black-2">Leave A comment</h5>
                <p className="text-variant-1 mt-8">
                  Your email address will not be published. Required fields are
                  marked *
                </p>
                <div id="comments" className="comments">
                  <div className="respond-comment">
                    <CommentForm />
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          {/* <div className="col-lg-4">
            <Sidebar />
          </div> */}
        </div>
      </div>

    </section>

  </>
  );
}
